import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

/**
 * CreateChallenge Page (Stub)
 * 
 * This page is currently not implemented. The backend does not have a /challenges
 * endpoint. Challenges are managed as Bounties in the platform.
 * 
 * TODO: Either implement /challenges backend endpoint or redirect to bounty creation
 */
const CreateChallenge: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after 3 seconds
    const timer = setTimeout(() => {
      navigate('/sponsor/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <AlertCircle className="w-16 h-16 text-yellow-500" />
        </div>
        <h1 className="text-2xl font-bold font-space text-primary-text mb-4">
          Feature Not Implemented
        </h1>
        <p className="text-primary-text font-space mb-6">
          Challenge creation is not currently available. This feature needs backend implementation.
        </p>
        <p className="text-sm text-gray-500 font-space mb-6">
          Redirecting to dashboard in 3 seconds...
        </p>
                <button
          onClick={() => navigate('/sponsor/dashboard')}
          className="bg-accent hover:bg-yellow-400 text-primary-text px-6 py-3 rounded-lg font-space font-semibold transition-colors"
        >
          Go to Dashboard Now
            </button>
      </div>
    </div>
  );
};

export default CreateChallenge;
